import { itemToBagFailure } from "../itemToBagFailure";
import { ITEM_TO_BAG_SUCCESS } from "../../constants";
import {
  ServiceError,
  SdkError,
  LoggedError
} from "../../../../../services/errors";
import { getToBagOperation } from "./getToBagOperation";
import { getItemsType } from "../../../common/selectors";

export const itemToBag =
  ({ variantId, id, seller }) =>
  async (dispatch, getState) => {
    try {
      const toBagOperation = getToBagOperation(getState());
      await toBagOperation({ variantId, id, seller });
    } catch (e) {
      if (e instanceof ServiceError || e instanceof SdkError) {
        return dispatch(itemToBagFailure({ id, e }));
      }
      throw new LoggedError(e, LoggedError.error);
    }

    const itemsType = getItemsType(getState());

    return dispatch({ type: ITEM_TO_BAG_SUCCESS, payload: { id, itemsType } });
  };
